import { Badge, Button, Dropdown } from 'antd';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SERVICE_REQUEST_TYPE, serviceRequestType } from '.';
import Icon, { ICON_NAME } from '../../../../components/Icon';
import { selectSetting } from '../../../../util/store/selectors';
import { propContainer } from '../../../../util/varibles/constants';
import { PlanSetting } from '../../../../util/varibles/userSetting';
import { updateUserSetting } from "../../../LoginPage/reducer";
import styles from './style.module.scss';

const Filter: React.FC = () => {
    const { [PlanSetting.SERVICE_REQUESTS_STATUS]: statusFilter } = useSelector(selectSetting([PlanSetting.SERVICE_REQUESTS_STATUS]))
    const [visible, setVisible] = useState(false);
    const dispatch = useDispatch();
    const onChange = (checked: boolean, key: SERVICE_REQUEST_TYPE) => {
        const ids = new Set(statusFilter || []);

        if (checked) {
            ids.delete(key);
        } else {
            ids.add(key);
        }

        dispatch(updateUserSetting([{
            [PlanSetting.SERVICE_REQUESTS_STATUS]: Array.from(ids),
        }]));
    };


    const ids = new Set(statusFilter);

    const items = [
        {
            className: '!cursor-default',
            key: 'filter',
            disabled: true,
            label: <div className='flex flex-col px-2 py-3'>
                <div className='text-[var(--colorMain)] text-[18px]'>Filter by status</div>
                <div className='flex gap-2 mt-2'>
                    {Object.keys(serviceRequestType).map(key => {
                        const { id, name, background, color } = serviceRequestType[key];
                        const isActive = ids.has(id);
                        return <div
                            key={key}
                            className={styles.optionFilter}
                            data-active={ids.has(key)}
                            style={{ '--bgItem': background, color } as any}
                            onClick={() => onChange(isActive, id)}
                        >
                            {name}
                        </div>
                    })}
                </div>
            </div>
        }
    ]

    return <Dropdown
        {...propContainer}
        open={visible}
        trigger={['click']}
        onOpenChange={setVisible}
        menu={{ items }}
        placement="bottomRight"
        arrow
        popupRender={(menus) => <>
            <div className={styles.filterLayout} onClick={() => setVisible(false)}></div>
            {menus}
        </>}
    >
        <Button className='bt-ghost h-32' data-is-show={visible}>
            <Badge dot={ids.size > 0} color="green">
                <Icon icon={ICON_NAME.FILTER} />
            </Badge>
            <span className='ml-5'>Filter</span>
        </Button>
    </Dropdown>
};

export default Filter
